<template>
  <div>
    <font-awesome-icon class="spinner" :icon="spinner" spin />
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import faSpinner from '@fortawesome/fontawesome-free-solid/faSpinner';

export default {
  components: {
    FontAwesomeIcon
  },
  props: {},
  data () {
    return {
      show: true,
      label: 'Loading...'
    };
  },
  computed: {
    spinner () {
      return faSpinner;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../stylesheets/variables.scss";
.spinner {
  color: $primary;
  font-size: $fs-2xl;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/spinner/Spinner.vue